<template>
  <div class="console_r">
    <!-- <sub-header :id="queryParams.hennery_id" name="devices"></sub-header> -->
    <div class="console_r_card">
      <div class="title">
        <b>{{currHenneryName}} - 设备列表<i @click="refresh" class="el-icon-refresh" title="刷新"></i></b>
        <span>当前记录：{{count}}</span>
      </div>
      <div class="con">
        <div class="con_top" style="padding: 20px 0;">
          <el-select v-model="queryParams.status" style="width: 200px">
            <!-- <el-option value="" label="全部">全部</el-option> -->
            <el-option v-for="(item, index) in statusList" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
          <el-button type="primary" @click="search" round>查询</el-button>
        </div>
        <el-table 
        :data="list" 
        style="width: 100%" 
        :default-sort = "{prop: 'building_name'}"
        border>
          <!-- <el-table-column prop="id" label="ID" width="60"></el-table-column> -->
          <el-table-column prop="building_name" label="分栋" sortable></el-table-column>
          <el-table-column prop="hostname" label="设备名称" width="105" sortable></el-table-column>
          <el-table-column prop="custom_name" label="设备昵称" width="105" sortable></el-table-column>
          <el-table-column label="设备当前状态" width="110">
            <template slot-scope="scope">
              <i :style="{color: (scope.row.status===1 || scope.row.status===3)?'green':'red'}" class="el-icon-s-opportunity"></i>
              <span style="margin-left: 5px">{{ scope.row.status2 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ip_address" label="设备IP地址" width="120"></el-table-column>
          <el-table-column prop="env_temp2" label="温度" width="80"></el-table-column>
          <el-table-column prop="env_humidity2" label="湿度" width="80"></el-table-column>
          <el-table-column prop="env_pressure2" label="大气压强" width="100"></el-table-column>
          <el-table-column prop="disk_usage2" label="磁盘使用" width="150"></el-table-column>
          <el-table-column prop="memory_usage2" label="内存使用" width="140"></el-table-column>
          <el-table-column prop="cpu_usage2" label="CPU使用"></el-table-column>
          <el-table-column prop="cpu_temp2" label="CPU温度"></el-table-column>
          <el-table-column label="上次心跳时间" min-width="110" width="168">
            <template slot-scope="scope">
              <span style="white-space: nowrap; padding-right: 5px">{{ scope.row.active_ts2.split(' ')[0] }}</span>
              <span style="white-space: nowrap">{{ scope.row.active_ts2.split(' ')[1] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="上次异常声音时间" min-width="110" width="168">
            <template slot-scope="scope">
              <span style="white-space: nowrap; padding-right: 5px">{{ scope.row.last_cluck_sick_ts2.split(' ')[0] }}</span>
              <span style="white-space: nowrap">{{ scope.row.last_cluck_sick_ts2.split(' ')[1] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="285" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="viewDetail(scope.row, 'device')" round>进入设备</el-button>
                <el-button type="primary" size="mini" @click="viewDetail(scope.row, 'monitor')" round>实时监听</el-button>
                <!-- <el-tooltip effect="light" content="由于监听会终止声音的采集工作，所以默认监听时间为2分钟，如果时间到了以后想继续监听，请再点击此按钮" placement="top-end">
                  <el-button type="primary" size="mini" @click="viewDetail(scope.row, 'monitor')" round>实时监听</el-button>
                </el-tooltip> -->
                <el-button type="danger" size="mini" @click="openModifyDialog(scope.row)" round>修改昵称</el-button>
              </template>
            </el-table-column>
        </el-table>
      </div>
      <!-- <div style="text-align: center">
        <el-pagination
        style="padding: 20px 0 40px"
        background
        layout="prev, pager, next"
        @current-change="currPageChange"
        :page-size="queryParams.limit"
        :total="count">
        </el-pagination>
      </div> -->
    </div>
    <!--弹框-->
    <el-dialog 
    class="dialog"
    :title="`设备${currDeviceName}`" 
    width="1000px"
    :visible.sync="deviceDialogVisible"
    @close="dialogClose">
      <div class="detail-item">
        <device-audio v-if="deviceDialogVisible" :id="currId"></device-audio>
      </div>
    </el-dialog>
    <el-dialog 
    class="dialog"
    title="修改设备昵称" 
    width="600px"
    :visible.sync="modifyDialogVisible">
      <div class="detail-item">
        <el-form ref="editPostParams" label-width="140px">
          <el-form-item label="设备昵称：">
            <el-input type="input" v-model="modifyCustomName" placeholder="请输入设备昵称"></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: right;">
          <el-button 
          type="primary"
          @click="modifyNickName()" 
          :disabled="!modifyCustomName || modifyCustomName === currCustomName"
          >修 改</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog 
    class="dialog"
    :title="`实时监听 - ${currDeviceName}`"
    width="600px"
    @close="mDialogClose"
    :visible.sync="monitorDialogVisible">
      <div class="detail-item">
        <div style="padding-top: 10px; line-height: 24px; color: #aab6e4;">由于监听会终止声音的采集工作，所以默认监听时间为2分钟，如果时间到了以后想继续监听，请再点击“开启监听”按钮。</div>
        <div style="padding: 40px 0 10px; text-align: center;">
          <el-button type="primary" :loading="monitorBtnText === monitorBtnTextList[1]" :disabled="monitorBtnText === monitorBtnTextList[1]" @click="getLiveStream()" round>{{monitorBtnText}}</el-button>
        </div>
        <div style="padding: 10px 0 20px; line-height: 24px; color: red;text-align: center;">{{monitorTip}}</div>
      </div>
    </el-dialog>
    <audio ref="liveStream" @ended="audioEnded" @play="onPlay" @pause="onPause" @loadedmetadata="onLoadedmetadata" controls style="display:none"></audio>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import moment from '@/libs/moment'
import { getDevicesApi, getDevicesCountApi, modifyDeviceNicknameApi, getLiveStreamApi, stopLiveStreamApi } from '@/api/user'
// import { getHenneryName } from '@/libs/util'
// import ShAudio from '@/components/Audio'
import SubHeader from '@/components/SubHeader'
import DeviceAudio from '@/components/DeviceAudio'

export default {
  name: 'Devices',
  components: {
    // ShAudio,
    DeviceAudio,
    // SubHeader
  },
  data() {
    return {
      currHenneryName: '',
      currAct: 'devices',
      queryParams: {
        skip: 0,
        limit: 100,
        status: 0,
        hennery_id: Number(this.$route.params.id)
        // id: 4
      },
      list: [],
      count: 0,
      statusList: [
        {
          name: '全部设备',
          value: 0
        },
        {
          name: '正常设备',
          value: 1
        },
        {
          name: '宕机设备',
          value: 2
        },
        // {
        //   name: '上传中设备',
        //   value: 3
        // }
      ],
      monitorDialogVisible: false,
      monitorBtnTextList: ['开启监听', '开启中...', '关闭监听'],
      monitorBtnText: '', //this.monitorBtnTextList[0],  //  启动中.../关闭监听
      monitorTip: '',
      deviceDialogVisible: false,
      currDeviceName: '',
      currDevicePort: '',
      currDeviceHostName: '',
      modifyDialogVisible: false,
      currId: null,
      currCustomName: '',
      modifyCustomName: '',
      timer: null,
      isPlay: false,
      liveAudio: null,
      timerIndex: 0,
      delay: 0
    }
  },
  methods: {
    dialogClose () {
      // console.log('close')
    },
    getList () {
      getDevicesApi(this.queryParams).then(res=>{
        let data = res.data.data.devices ? res.data.data.devices : []
        let uploadingData = []
        // this.list = res.data.data.devices
        this.currHenneryName = res.data.data.hennery.name
        data.forEach((item) => {
          item.env_temp2 = item.env_temp <= -300 ? '' : item.env_temp.toFixed(2) + '℃'
          item.env_humidity2 = item.env_humidity <= -300 ? '' : item.env_humidity.toFixed(2) + '%'
          item.env_pressure2 = item.env_pressure <= -300 ? '' : item.env_pressure.toFixed(2) + 'hPa'
          item.active_ts2 = item.active_ts ? moment(item.active_ts).format("YYYY-MM-DD HH:mm:ss") : ''
          item.last_cluck_sick_ts2 = item.last_cluck_sick_ts ? moment(item.last_cluck_sick_ts).format("YYYY-MM-DD HH:mm:ss") : ''
          item.disk_usage2 = ((item.disk_usage/100)*item.disk_total).toFixed(2) + 'GB / ' + item.disk_total + 'GB'
          item.memory_usage2 = item.memory_usage + '% / ' + item.memory_total + 'MB'
          item.cpu_usage2 = item.cpu_usage + '%'
          item.cpu_temp2 = item.cpu_temp.toFixed(2) + '℃'
          item.port = '40' + item.hostname.substr(-3, 3)
          item.name = !!item.custom_name ? item.custom_name : item.hostname
          item.show_name = !!item.custom_name ? `${item.hostname}（${item.custom_name}）` : item.hostname
          if(item.status === 1) {
            item.status2 = '正常'
          } else if(item.status === 3) {
            item.status2 = '上传中'
            // uploadingData.push(item)
          } else {
            item.status2 = '宕机'
          }
        })
        // this.list = this.queryParams.status === 3 ? uploadingData : data
        this.list = data.sort((a, b) => a.hostname.localeCompare(b.hostname))
        this.loadingData = false
      }).catch(() => {
        this.loadingData = false
      })
    },
    getCount () {
      getDevicesCountApi(this.queryParams).then(res => {
        this.count = res.data.data.count
      })
    },
    getLiveStream () {
      let _this = this
      _this.monitorTip = ''
      _this.timerIndex = 0
      if(_this.monitorBtnText === _this.monitorBtnTextList[1]) {
        return
      }
      if(_this.monitorBtnText === _this.monitorBtnTextList[2]) {
        _this.pause()
        return
      }
      getLiveStreamApi({hostname: this.currDeviceHostName}).then(res => {
        console.log('livestream', res.data)
        const audioName = res.data.data.audio_name
        console.log(audioName)
        // this.getAudioStream(audioName)
        // return
        _this.monitorBtnText = '开启中...'
        _this.timer = setInterval(()=> {
          if(_this.timerIndex > 10) {
            this.clearTimer()
            _this.monitorBtnText = _this.monitorBtnTextList[0]
            _this.monitorTip = '开启监听失败，请重新开启监听'
          } 
          else if (_this.timerIndex > _this.delay && _this.timerIndex <= 10) {
            _this.timerIndex++ 
            _this.play2(audioName)
          }
          else {
            _this.timerIndex++ 
            // _this.getAudioStream(audioName)
          }
        }, 1000)
      })
    },
    stopLiveStream () {
      stopLiveStreamApi({hostname: this.currDeviceHostName}).then(res => {
        this.monitorBtnText = this.monitorBtnTextList[0]
      })
    },
    onLoadedmetadata () {
      console.log(11)
      // clearInterval(this.timer)
      // this.monitorBtnText = '关闭监控'
    },
    getAudioStream (audioName) {
      console.log(this.timerIndex)
      let _this = this
      fetch('/stream/40204/' + audioName).then(data => {
        console.log(data)
        const blob = data.blob()
        return blob
      }).then(blob => {
        console.log(blob)
        // clearInterval(_this.timer)
        // _this.timerIndex = 0
        // _this.monitorBtnText = _this.monitorBtnTextList[2]
        // let url = window.URL.createObjectURL(new Blob([blob]));
        // let dom = _this.$refs.liveStream
        // dom.pause()
        // // dom.src = 'https://stream.starhelix.cn:40204/out.mp3'
        // dom.src = url
        // dom.play()
        // if(_this.liveAudio) {
        //   _this.liveAudio.pause()
        //   _this.liveAudio = null
        // }
        // // console.log('/stream/40204/' + audioName)
        // _this.liveAudio = new Audio(url)
        // _this.liveAudio.play()
        // _this.play2(audioName)
        setTimeout(() => {
          _this.clearTimer()
          _this.monitorBtnText = _this.monitorBtnTextList[2]
          _this.play2(audioName)
        }, 1000)
      })
    },
    openModifyDialog (item) {
      this.modifyDialogVisible = true
      this.currId = item.id
      this.currCustomName = item.custom_name
      this.modifyCustomName = item.custom_name
    },
    modifyNickName () {
      modifyDeviceNicknameApi(this.currId, {custom_name: this.modifyCustomName}).then(res=>{
        Message.success('修改成功')
        this.refresh()
        this.modifyDialogVisible = false
      }).catch(() => {
        Message.error('修改失败')
      })
    },
    search () {
      this.queryParams.skip = 0
      this.refresh()
    },
    refresh () {
      this.getList()
      this.getCount()
    },
    currPageChange (currPage) {
      this.queryParams.skip = (currPage - 1) * this.queryParams.limit
      this.getList()
    },
    viewDetail (item, type) {
      this[`${type}DialogVisible`] = true
      // this.deviceDialogVisible = true
      this.currId = item.id
      this.currDeviceName = item.show_name
      this.currDevicePort = item.port
      this.currDeviceHostName = item.hostname
    },
    mDialogClose () {
      // this.monitorDialogVisible = false
      if(this.liveAudio) {
        this.liveAudio.pause()
        this.liveAudio = null
        this.stopLiveStream()
      }
      if(this.timer) {
        this.clearTimer()
        this.monitorBtnText = this.monitorBtnTextList[0]
      }
    },
    clearTimer () {
      clearInterval(this.timer)
      this.timerIndex = 0
    },
    play (audioName) {
      console.log(22)
      let dom = this.$refs.liveStream
      dom.pause()
      // dom.src = 'https://stream.starhelix.cn:40204/out.mp3'
      dom.src = 'https://huayu.starhelix.cn/stream/40204/' + audioName
      dom.play()
    },
    play2 (audioName) {
      if(this.liveAudio) {
        this.liveAudio.pause()
        this.liveAudio = null
      }
      this.liveAudio = new Audio(`https://huayu.starhelix.cn/stream/${this.currDevicePort}/` + audioName)
      this.liveAudio.play()
    },
    pause () {
      // let dom = this.$refs.liveStream
      // dom.pause()
      this.stopLiveStream()
      this.monitorBtnText = this.monitorBtnTextList[0]
      this.liveAudio.pause()
    },
    onPlay () {
      // this.isPlay = true
      console.log(111)
      this.clearTimer()
    },
    onPause () {
      console.log('pause')
      // this.isPlay = false
    },
    audioEnded () {
      console.log('end')
      this.isPlay = false
      this.monitorBtnText = this.monitorBtnTextList[0]
    },
  },
  watch: {
    isPlay (value) {
      console.log(value)
      if(value) {
        this.play()
      }
    },
    liveAudio (value) {
      let _this = this
      if(value) {
        _this.liveAudio.addEventListener('play', function () {
            console.log('音频开始播放')
            if(_this.timerIndex > _this.delay) {
              _this.monitorBtnText = _this.monitorBtnTextList[2]
              _this.clearTimer()
            }
        });
        // _this.liveAudio.addEventListener('timeupdate', function (e) {
        //   console.log(_this.liveAudio.currentTime, _this.liveAudio.duration)
        //     console.log('进度条', e)
        //     // if(_this.timerIndex > 4) {
        //     //   _this.timerIndex = 0
        //     //   _this.monitorBtnText = _this.monitorBtnTextList[2]
        //     //   clearInterval(_this.timer)
        //     // }
        // });
        _this.liveAudio.addEventListener('pause', function () {
            console.log('音频暂停播放')
            _this.monitorBtnText = _this.monitorBtnTextList[0]
        });
        _this.liveAudio.addEventListener('ended', function () {
            console.log('音频播放结束')
            _this.monitorBtnText = _this.monitorBtnTextList[0]
            _this.liveAudio = null
        });
      }
    }
  },
  created(){
    this.$store.commit('setCurrHenneryId', this.$route.params.id)
    this.refresh()
    this.monitorBtnText = this.monitorBtnTextList[0]
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import 'poultry.scss';
.switch-day {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  text-align: center;
  padding: 20px 0;
}
.bar-mark {
  display: flex;
  justify-content: center;
  align-items: center;
  .bar-mark-item {
    display: flex;
    // justify-content: center;
    align-items: center;
    padding: 0 15px;
    .bar-mark-color {
      width: 30px;
      height: 15px;
      margin-right: 2px;
    }
    .bar-mark-name {
      color: #aab6e4;
    }
  }
}
.time-scroll {
  overflow: auto;
  .time-axis {
    // display: flex;
    white-space: nowrap;
    padding: 100px 50px;
    .time-axis-item {
      display: inline-block;
      .item-bar {
        width: 5px;
        height: 30px;
        background-color: gray;
        position: relative;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
        .item-scale {
          width: 100px;
          text-align: center;
          position: absolute;
          right: -45px;
          top: 30px;
          // background-color: blue;
          &::after {
            content: '';
            display: inline-block;
            width: 1px;
            height: 5px;
            background-color: #ffffff;
            position: absolute;
            left: 50px;
            top: 0;
          }
        }
      }
    }
  }
}
</style>
